import { t } from 'app/i18l'
import React, { createContext, useEffect } from 'react'
import { Platform } from 'react-native'
import { useStoredState } from 'shared/hooks/stored_state'
import { useUser } from 'users/queries/detail'
import { useNotificationsSummary } from './queries/summary'
import { NotificationsSummaryItem } from './types'

export const WebNotificationsContext = createContext({})

interface Props {
  children: React.ReactNode
}

export function WebNotificationsProvider(props: Props) {
  const [notifications, setNotifications] = useStoredState<
    NotificationsSummaryItem[]
  >('old_push_notifications')
  const notificationsQuery = useNotificationsSummary()
  const { data: user } = useUser()

  useEffect(() => {
    if (Platform.OS === 'web' && user?.webForCrew) {
      return
    }
    if (notificationsQuery.data?.notifications) {
      if (!notifications) {
        setNotifications(notificationsQuery.data.notifications)
      } else {
        const newNotifications = notificationsQuery.data.notifications.filter(
          notification => {
            return !notifications.some(
              staleNotification =>
                staleNotification.message === notification.message
            )
          }
        )
        if (newNotifications.length) {
          newNotifications.forEach(showWebNotification)
          if (notificationsQuery.data.unreadCount > 3) {
            showWebNotification({
              title: t('multipleNotifications'),
              message: t('multipleNotificationsDesc', {
                count: notificationsQuery.data.unreadCount,
              }),
            }).catch(e => null)
          }
        }
        setNotifications(notificationsQuery.data.notifications)
      }
    }
  }, [
    notifications,
    notificationsQuery.data,
    setNotifications,
    user?.webForCrew,
  ])

  return (
    <WebNotificationsContext.Provider value={{}}>
      {props.children}
    </WebNotificationsContext.Provider>
  )
}

async function showWebNotification(notification: NotificationsSummaryItem) {
  if (Platform.OS === 'web' && Notification.permission === 'granted') {
    const notif = new Notification(notification.title, {
      body: notification.message,
    })
    return notif
  }
}
